export class FiltroEnderecoPorLogradouroModel {
    public uf: string;
    public cidade: string;
    public logradouro: string;
  }
  


// WEBPACK FOOTER //
// ./src/app/shared/model/filtro-endereco-logradouro.ts